















































































































































































































































































































import { getFlagEmoji } from "@/lib/CountryCodeHelper";
import PermissionMixin from "@/mixins/PermissionMixin.vue";
import { IInvoice, DocumentDirectionEnum, InvoiceTypeEnum } from "@/models/invoice.entity";
import { mixins } from "vue-class-component";
import { Component, Prop, Ref, Watch } from "vue-property-decorator";
import { formatCurrency } from "@/lib/utility/currency-helper";
import InvoiceFormLinesTableRow from "./InvoiceFormLinesTableRow.vue";
import { InvoiceLine } from "@/models/invoice-line.entity";
import RulesMixin from "@/mixins/RulesMixin.vue";
import InvoicePartyForm from "./InvoicePartyForm.vue";
import Tooltip from "../utility/tooltip.vue";
import { ICompany } from "@/models/company.entity";
import CompanySelection from "../partner/report/v2/contact/CompanySelection.vue";

@Component({
  components: {
    InvoiceFormLinesTableRow,
    InvoicePartyForm,
    CompanySelection,
    Tooltip
  },
  filters: {
    getFlagEmoji
  }
})
export default class InvoiceFormPreview extends mixins(PermissionMixin, RulesMixin) {
  readonly formatCurrency = formatCurrency;
  readonly InvoiceLine = InvoiceLine;
  readonly DocumentDirectionEnum = DocumentDirectionEnum;

  buyerCompany: ICompany | null = null;
  sellerCompany: ICompany | null = null;

  @Ref("sellerForm") sellerForm!: InvoicePartyForm;

  @Ref("buyerForm") buyerForm!: InvoicePartyForm;

  @Prop()
  value!: IInvoice;

  @Prop({ default: false })
  readonly!: boolean;

  @Watch("sellerCompany")
  onSellerCompanyChange() {
    this.$log.debug(this.sellerCompany);

    if (this.sellerCompany) {
      this.value.seller = this.sellerCompany.invoiceParty;
      this.value.sellerCompany = this.sellerCompany;
    }
  }

  @Watch("buyerCompany")
  onBuyerCompanyChange() {
    this.$log.debug(this.buyerCompany);

    if (this.buyerCompany) {
      this.value.buyer = this.buyerCompany.invoiceParty;
      this.value.buyerCompany = this.buyerCompany;
    }
  }

  get taxRates() {
    return this.value.taxRates;
  }

  get invoiceTypes() {
    return [InvoiceTypeEnum.COMMERCIAL, InvoiceTypeEnum.CREDIT_NOTE];
  }

  addInvoiceLine() {
    this.value.lineItems.push(new InvoiceLine());
  }

  removeInvoiceLine(index: number) {
    this.value.lineItems.splice(index, 1);
  }

  addNoteEntry(note = "") {
    if (!this.value.notes) {
      this.value.notes = [];
    }
    this.value.notes.push(note);
  }

  removeNoteEntry(index: number) {
    if (!this.value.notes) {
      return;
    }

    this.value.notes.splice(index, 1);
  }
}
